<!-- @format -->

<ng-container *transloco="let t">
  <fudis-section [class]="'fudis-mt-md'" [level]="2" [titleVariant]="'lg'" [title]="'2. ' + t('ADD_TO_PLAN_WIZARD.PREVIEW_AND_CONFIRM')">
    <fudis-section-content>
      <fudis-body-text [variant]="'md-light'">{{ t("ADD_TO_PLAN_WIZARD.PREVIEW_AND_CONFIRM_DESCRIPTION") }}</fudis-body-text>
      <fudis-heading [class]="'fudis-mt-sm'" [level]="3" [variant]="'md'">
        {{ t("ADD_TO_PLAN_WIZARD.SELECTED_COURSE_UNIT") }}</fudis-heading
      >
      @if (wizardData) {
        @if (wizardData.courseUnit) {
          <sis-plan-structure-course-unit
            [courseUnit]="wizardData.courseUnit"
            [planStateObject]="wizardData.planStructureData.planStateAndData.planStateObject"
            [planData]="wizardData.planStructureData.planStateAndData.planData"
            [headingLevel]="4"
            [nameClickable]="false"
            [showAttainment]="false">
          </sis-plan-structure-course-unit>
        } @else if (wizardData.customCourseUnitAttainment) {
          <sis-plan-structure-custom-course-unit-attainment
            [customCourseUnitAttainment]="wizardData.customCourseUnitAttainment"
            [planStateObject]="wizardData.planStructureData.planStateAndData.planStateObject"
            [nameClickable]="false"
            [headingLevel]="4">
          </sis-plan-structure-custom-course-unit-attainment>
        }
        <fudis-heading [level]="3" [variant]="'md'" class="fudis-mt-md">{{ t("ADD_TO_PLAN_WIZARD.DESTINATION") }}</fudis-heading>
        <fudis-grid [columns]="{ sm: 1, md: 2 }" [classes]="'fudis-mt-sm'">
          <fudis-dl [columns]="1">
            <fudis-dl-item>
              <fudis-dt [contentText]="t('ENTITY_NAMES.plan')" />
              <fudis-dd [contentText]="wizardData.planStructureData.plan.name" />
            </fudis-dl-item>
          </fudis-dl>
          <app-plan-header-info-list [currentPlan]="wizardData.planStructureData.plan"></app-plan-header-info-list>
        </fudis-grid>

        <fudis-heading [class]="'fudis-mt-sm'" [level]="4" [variant]="'md'">
          {{ t("ADD_TO_PLAN_WIZARD.SELECTED_DESTINATION") }}
        </fudis-heading>
        @if (isModuleValidationInvalid()) {
          <fudis-notification [variant]="'warning'" class="sis-mb-sm">
            <fudis-body-text>{{ t("ADD_TO_PLAN_WIZARD.VALIDATION.TOO_MANY_SELECTIONS") }}</fudis-body-text>
          </fudis-notification>
        }
        <div class="add-to-plan-wizard__module-summary-box">
          <app-plan-structure-module-summary [headingLevel]="5" [module]="module" [planStructureData]="wizardData.planStructureData" />
        </div>
      }
    </fudis-section-content>
  </fudis-section>

  <sis-wizard-step-buttons
    [backButtonTitle]="t('SIS_COMPONENTS.BUTTON.PREVIOUS')"
    [forwardButtonTitle]="t('ADD_TO_PLAN_WIZARD.CONFIRM_AND_GO_TO_PLAN')"
    (back)="previous.emit()"
    (forward)="confirm.emit()" />
</ng-container>
